const { getCampaignContent, updateCampaignContent, updateCampaignCurrentContent } = require('../../services/campaignv1');

exports.fetchCampaignContent = async function (instance) {
  try {
    this.fetchingData = true;

    // Fetch Details
    let response = await getCampaignContent(instance.campaignId);
    let campaign = response.data.campaign;
    if (!campaign) {
      instance.$router.replace({ name: '404' });
      return;
    }

    // Prepare Campaign Contents
    // // Handle web social proof message parsing.
    // if (instance.content && instance.content.content && instance.content.content.on_site_content) {
    //   instance.content.content = JSON.parse(instance.content.content.on_site_content);
    // } else if (instance.content && instance.content.content && instance.content.content.in_app_content) {
    //   instance.content.content = JSON.parse(instance.content.content.in_app_content);
    // }

    // instance.fetchingData = false;

    // // Render campaign content.
    // delete instance.content.campaign;
    // requestAnimationFrame(() => {
    //   instance.$refs.contentBuilder.renderCampaignContent(instance.content, instance.campaign);
    //   instance.hasUnsavedChanges = false;
    // });

    instance.campaign = campaign;
    instance.fetchingData = false;
    requestAnimationFrame(() => {
      instance.$refs.abTestWrapper.renderCampaignContent(campaign, response.data.content);
    });
  } catch (err) {
    instance.reportError(err);
    instance.errorToast('Failed to read campaign content. Please contact support.');
    instance.fetchingData = false;
  }
};

exports.validateAndSave = async (instance) => {
  // Save Content
  instance.savingCampaign = true;
  try {
    // Validate all variants first.
    let validationResult = await instance.$refs.abTestWrapper.validateAllVariants();
    if (!validationResult.valid) {
      instance.savingCampaign = false;
      console.log('Validation Failed', validationResult, instance.$refs.abTestWrapper.currentVariant);
      if (validationResult.index !== instance.$refs.abTestWrapper.currentVariant) {
        instance.errorToast('Please fix the issues in variant ' + String.fromCharCode(65 + validationResult.index));
      }
      return false;
    }

    // Read Content.
    let content = await instance.$refs.abTestWrapper.readAllVariantsContent();

    // Save Content
    await updateCampaignContent(instance.campaignId, { content: content });

    instance.savingCampaign = false;
    return true;
  } catch (err) {
    console.log('Error while saving campaign content:', err);
    if (err.data.length > 0) {
      instance.errorToast(err.data);
    } else {
      instance.errorToast('Failed to save changes. Please contact support.');
    }
    instance.savingCampaign = false;
    instance.reportError(err);
    return false;
  }
};

exports.validateAndSaveCurrentVariant = async (instance) => {
  // Save Content
  instance.savingCampaign = true;
  try {
    // console.log('validateAndSaveCurrentVariant is disabled');
    // Validate all variants first.
    let validationResult = await instance.$refs.abTestWrapper.validateCurrentVariant();
    if (!validationResult.valid) {
      instance.savingCampaign = false;
      console.log('Validation Failed', validationResult, instance.$refs.abTestWrapper.currentVariant);
      if (validationResult.index !== instance.$refs.abTestWrapper.currentVariant) {
        instance.errorToast('Please fix the issues in variant ' + String.fromCharCode(65 + validationResult.index));
      }
      return false;
    }

    // Read Content.
    let content = await instance.$refs.abTestWrapper.readCurrentVariantsContent();

    // Save Content
    await updateCampaignCurrentContent(instance.campaignId, content['content'].variant, { content: content });

    instance.savingCampaign = false;
    return true;
  } catch (err) {
    console.log('Error while saving campaign content:', err);
    if (err.data.length > 0) {
      instance.errorToast(err.data);
    } else {
      instance.errorToast('Failed to save changes. Please contact support.');
    }
    instance.savingCampaign = false;
    instance.reportError(err);
    return false;
  }
};

exports.goBack = async (instance) => {
  try {
    let result = await instance.$confirm('You have unsaved changes, save and proceed?', 'Save Changes?', {
      distinguishCancelAndClose: true,
      confirmButtonText: 'Save Changes',
      cancelButtonText: 'Ignore Changes'
    });

    // Save changes
    result = await exports.validateAndSave(instance);
    if (!result) return;
  } catch (err) {
    // Igore changes
  }

  // Go To Previous
  instance.savingCampaign = true;
  instance.$router.push({ name: 'campaignTargetAudiance', params: { id: instance.campaignId } });
};

exports.onGoNext = async (instance) => {
  let result = await exports.validateAndSave(instance);
  if (result) {
    // Redirect to review page.
    instance.$router.push(`/campaign/update/goals/${instance.campaignId}`);
  }
};

exports.saveDraft = async (instance) => {
  let result = await exports.validateAndSave(instance);
  if (result) {
    instance.successToast('Draft Saved.');
  }
};

exports.saveCurrentVariant = async (instance) => {
  let result = await exports.validateAndSaveCurrentVariant(instance);
  if (result) {
    instance.successToast('Draft Saved.');
  }
};
